import React from 'react';
import HomeViewContainer from './views/HomeViewContainer';
import RecordsViewContainer from './views/RecordsViewContainer';
import ProvidersViewContainer from './views/ProvidersViewContainer';
import PermissionsViewContainer from './views/PermissionsViewContainer';
import ImportViewContainer from './views/ImportViewContainer';
import AuditViewContainer from './views/AuditViewContainer';
import AccountViewContainer from './views/AccountViewContainer';

export default function MainViewContainer({
  currentView,
  recordsList,
  permissionsList,
  providersList,
  auditLogs,
  user,
  emailVerified,
  onNavigate,
  onDeleteRecord,
  onEditRecord,
  onGrantPermission,
  onViewRecord,
  onAddProvider,
  onUpdateProvider,
  onRevokePermission,
  onOpenUpload,
  onOpenUpdateProfile,
  onOpenChangePassword,
  onResendVerification
}) {
  switch (currentView) {
    case 'home':
      return <HomeViewContainer records={recordsList} permissions={permissionsList} onNavigate={onNavigate} />;
    case 'records':
      return (
        <RecordsViewContainer
          records={recordsList}
          permissions={permissionsList}
          onDeleteRecord={onDeleteRecord}
          onEditRecord={onEditRecord}
          onGrantPermission={onGrantPermission}
          onViewRecord={onViewRecord}
        />
      );
    case 'providers':
      return (
        <ProvidersViewContainer
          records={recordsList}
          providers={providersList}
          permissions={permissionsList}
          onAddProvider={onAddProvider}
          onUpdateProvider={onUpdateProvider}
          onGrantPermission={onGrantPermission}
        />
      );
    case 'permissions':
      return (
        <PermissionsViewContainer
          records={recordsList}
          providers={providersList}
          permissions={permissionsList}
          onRevokePermission={onRevokePermission}
          onGrantPermission={onGrantPermission}
        />
      );
    case 'import':
      return <ImportViewContainer onOpenUpload={onOpenUpload} />;
    case 'audit':
      return <AuditViewContainer logs={auditLogs} />;
    case 'account':
      return (
        <AccountViewContainer
          user={user}
          emailVerified={emailVerified}
          auditLogs={auditLogs}
          onUpdateProfile={onOpenUpdateProfile}
          onChangePassword={onOpenChangePassword}
          onResendVerification={onResendVerification}
        />
      );
    default:
      return null;
  }
}
